import React from 'react';
import {observer} from 'mobx-react';
import FormError from 'shared/components/FormError';

const ReadOnlyItem = observer(({children, errorMessage}) => {
  return (
    <div className='p2 mb2 bg-athens rounded'>
      <div className='inline-block'>
        {children}
      </div>
      <div className='ml2'>
        <FormError message={errorMessage} />
      </div>
    </div>
  );
});

export default ReadOnlyItem;
